import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import FeatherIcon from "feather-icons-react";
import EvaluationForm from "./EvaluationForm";
import NoteForm from "./NoteForm";

class Evaluation extends Component {
    state = {
        isModal: false,
        loading: true,
        loadError: false,
        formData: null,
        sectionclasse: "",
        isNoteModal: false,
        evaluationSelected: null,
        sections: [],
        schedules: [],
        displayArray: []
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        this.setState({ loading: true, loadError: false });
        try {
            const [sectionsResponse, schedulesResponse] = await Promise.all([
                axios.get("sections"),
                axios.get("schedules")
            ]);

            const sections = sectionsResponse?.status === 200 ? sectionsResponse.data : [];
            const schedules = schedulesResponse?.status === 200 ? schedulesResponse.data : [];

            this.setState({ sections, schedules, loading: false, loadError: false });
        } catch (error) {
            this.setState({ loading: false, loadError: true });
        }
    };

    showNoteModal = (evaluation) => {
        this.setState((state) => ({
            isNoteModal: !state.isNoteModal,
            evaluationSelected: evaluation
        }));
    };

    showModal = (evaluation = null, sectionclasse = null) => {
        this.setState((state) => ({
            sectionclasse,
            isModal: !state.isModal,
            formData: evaluation
        }));
    };

    delete = (evaluationId) => {
        if (!window.confirm("Supprimer définitivement cette évaluation ?")) return;
        axios.delete(`evaluations/${evaluationId}`)
            .then(() => this.loadData())
            .catch(() => {});
    };

    handleCheck = (val) => {
        const permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some((item) => val === item.permission);
    };

    toggleSection = (sectionId) => {
        this.setState((state) => ({
            displayArray: state.displayArray.includes(sectionId)
                ? state.displayArray.filter((id) => id !== sectionId)
                : [...state.displayArray, sectionId]
        }));
    };

    toggleAllSections = (sectionIds) => {
        this.setState((state) => ({
            displayArray: state.displayArray.length === sectionIds.length ? [] : sectionIds
        }));
    };

    getSections = () => {
        const user = JSON.parse(localStorage.getItem("user")) ? JSON.parse(localStorage.getItem("user")) : false;
        const canSeeAll = this.handleCheck("Profil admin");
        const excludedPeriods = [3, 6, 7];
        const sectionGroups = new Map();

        this.state.sections.forEach((section) => {
            const sectionClasses = Array.isArray(section.sectionclasses) ? section.sectionclasses : [];
            sectionClasses.forEach((sectionClass) => {
                const relevantSchedules = this.state.schedules.filter((schedule) => {
                    const sameClass = schedule.sectionclasselesson?.sectionclass?.id === sectionClass.id;
                    const sameTeacher = !!user?.staff?.id && schedule.sectionclasselesson?.staffId === user.staff.id;
                    return sameClass && !excludedPeriods.includes(schedule.periodeId) && (sameTeacher || canSeeAll);
                });

                if (!relevantSchedules.length) return;

                if (!sectionGroups.has(section.id)) {
                    sectionGroups.set(section.id, { section, classes: [] });
                }

                const group = sectionGroups.get(section.id);
                const evaluations = relevantSchedules.flatMap((schedule) => {
                    const list = Array.isArray(schedule.evaluations) ? schedule.evaluations : [];
                    return list.map((evaluation) => ({
                        ...evaluation,
                        schedule,
                        sectionClass
                    }));
                });

                group.classes.push({ sectionClass, schedules: relevantSchedules, evaluations });
            });
        });

        return [...sectionGroups.values()]
            .sort((a, b) => (a.section.entitled_section || "").localeCompare(b.section.entitled_section || ""))
            .map((group) => ({
                ...group,
                classes: group.classes.sort((a, b) => {
                    const first = `${a.sectionClass.class?.short_entitled_class || ""} ${a.sectionClass.title || ""}`;
                    const second = `${b.sectionClass.class?.short_entitled_class || ""} ${b.sectionClass.title || ""}`;
                    return first.localeCompare(second, "fr", { numeric: true });
                })
            }));
    };

    getEvaluationPercent = (evaluation) => {
        const notes = Array.isArray(evaluation.notes) ? evaluation.notes : [];
        const total = notes.reduce((sum, note) => sum + Number(note.note || 0), 0);
        const max = Number(evaluation.max || 0);
        if (!notes.length || !max) return 0;
        return (total * 100) / (max * notes.length);
    };

    renderEvaluationCard = (evaluation, sectionClass) => {
        const percent = this.getEvaluationPercent(evaluation);
        const schedule = evaluation.schedule;
        const notesCount = Array.isArray(evaluation.notes) ? evaluation.notes.length : 0;
        const studentCount = Number(schedule?.sectionclasselesson?.sectionclass?.students?.length || 0);
        const periodLabel = schedule?.periode?.periode || `${schedule?.periodeId || ""} période`;
        const lessonName = schedule?.sectionclasselesson?.lesson?.short_entitled_lesson || "Évaluation";
        const classLabel = `${sectionClass.class?.short_entitled_class || ""} ${sectionClass.title || ""}`.trim();

        return (
            <div className="col-md-6 col-xl-4" key={evaluation.id}>
                <div className="card shadow-sm h-100 border-0">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start gap-2">
                            <div>
                                <div className="text-primary small fw-bold">{periodLabel} · {schedule?.year?.year || "Année"}</div>
                                <h6 className="mt-2 mb-1 fw-bold">{lessonName}</h6>
                                <div className="text-muted small">{evaluation.reason_evaluation || "Évaluation"}</div>
                            </div>
                            <span className={percent < 50 ? "badge rounded-pill bg-danger-subtle text-danger" : "badge rounded-pill bg-primary-subtle text-primary"}>{percent.toFixed(1)}%</span>
                        </div>

                        <div className="mt-3 small text-muted">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>Note maximale</span>
                                <span className="fw-semibold text-dark">{evaluation.max}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>Élèves notés</span>
                                <span className="fw-semibold text-dark">{notesCount} / {studentCount || "—"}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <span>Classe</span>
                                <span className="fw-semibold text-dark">{classLabel}</span>
                            </div>
                        </div>

                        <div className="mt-3 d-flex justify-content-between align-items-center">
                            <div className="small text-muted">{schedule?.date_start || evaluation.created_at || "—"}</div>
                            <div className="d-flex align-items-center gap-2">
                                {this.handleCheck("Ajouter note") && (
                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showNoteModal(evaluation.id)} title="Ajouter une note">
                                        <FeatherIcon icon="activity" size="14" />
                                    </button>
                                )}
                                {this.handleCheck("Ajouter note") && (
                                    <Link to={`#/evaluations/${evaluation.id}/questions`} className="btn btn-sm btn-outline-secondary" title="Questions">
                                        <FeatherIcon icon="clipboard" size="14" />
                                    </Link>
                                )}
                                {percent === 0 && this.handleCheck("Modifier evaluation") && (
                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(evaluation, sectionClass)} title="Modifier l’évaluation">
                                        <FeatherIcon icon="edit-2" size="14" />
                                    </button>
                                )}
                                {percent === 0 && this.handleCheck("Supprimer evaluation") && (
                                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => this.delete(evaluation.id)} title="Supprimer l’évaluation">
                                        <FeatherIcon icon="trash-2" size="14" />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderClass = ({ sectionClass, evaluations }, section) => {
        const className = `${sectionClass.class?.short_entitled_class || ""} ${sectionClass.title || ""}`.trim();
        return (
            <article className="student-class-card" key={sectionClass.id}>
                <div className="student-class-card__header">
                    <div className="student-class-card__title">
                        <span className="student-class-card__icon"><FeatherIcon icon="book-open" size="18" /></span>
                        <div>
                            <h3>{className || "Classe"}</h3>
                            <span>{evaluations.length} {evaluations.length > 1 ? "évaluations" : "évaluation"} · {section.short_entitled_section || section.entitled_section}</span>
                        </div>
                    </div>
                    <div className="student-class-card__actions">
                        {this.handleCheck("Ajouter evaluation") && (
                            <button type="button" className="btn btn-sm btn-primary" onClick={() => this.showModal(null, sectionClass)}>
                                <FeatherIcon icon="plus-circle" size="16" /> Ajouter
                            </button>
                        )}
                    </div>
                </div>
                <div className="student-class-card__table">
                    {evaluations.length > 0 ? (
                        <div className="row g-3">
                            {evaluations.map((evaluation) => this.renderEvaluationCard(evaluation, sectionClass))}
                        </div>
                    ) : (
                        <div className="students-feedback" style={{ minHeight: "180px", marginTop: 0 }}>
                            <span className="students-feedback__icon"><FeatherIcon icon="clipboard" size="28" /></span>
                            <h2>Aucune évaluation</h2>
                            <p>Cette classe n’a pas encore d’évaluation publiée.</p>
                        </div>
                    )}
                </div>
            </article>
        );
    };

    render() {
        const sectionGroups = this.getSections();
        const sectionIds = sectionGroups.map(({ section }) => section.id);
        const evaluationCount = sectionGroups.reduce((total, group) => total + group.classes.reduce((count, item) => count + item.evaluations.length, 0), 0);
        const classesCount = sectionGroups.reduce((total, group) => total + group.classes.length, 0);
        const notesCount = sectionGroups.reduce((total, group) => total + group.classes.reduce((count, item) => count + item.evaluations.reduce((sum, evaluation) => sum + (Array.isArray(evaluation.notes) ? evaluation.notes.length : 0), 0), 0), 0);

        return (
            <main className="students-page">
                <Helmet><title>{process.env.REACT_APP_NAME} | Évaluations</title></Helmet>

                <header className="students-hero">
                    <div className="students-hero__content">
                        <span className="students-hero__eyebrow">Gestion scolaire</span>
                        <h1>Évaluations</h1>
                        <p>Consultez les évaluations par classe, suivez les notes et gérez les accès rapidement.</p>
                    </div>
                    <div className="students-hero__actions">
                        {this.handleCheck("Ajouter evaluation") && (
                            <button type="button" className="btn btn-primary students-hero__action" onClick={() => this.showModal(null, null)}>
                                <FeatherIcon icon="plus-circle" size="18" /> Nouvelle évaluation
                            </button>
                        )}
                    </div>
                </header>

                {!this.state.loading && !this.state.loadError && (
                    <section className="students-stats" aria-label="Résumé des évaluations">
                        <article className="students-stat">
                            <span className="students-stat__icon"><FeatherIcon icon="clipboard" size="20" /></span>
                            <div><strong>{evaluationCount}</strong><span>Évaluations</span></div>
                        </article>
                        <article className="students-stat">
                            <span className="students-stat__icon students-stat__icon--success"><FeatherIcon icon="book-open" size="20" /></span>
                            <div><strong>{classesCount}</strong><span>Classes concernées</span></div>
                        </article>
                        <article className="students-stat">
                            <span className="students-stat__icon students-stat__icon--warning"><FeatherIcon icon="layers" size="20" /></span>
                            <div><strong>{sectionGroups.length}</strong><span>Sections suivies</span></div>
                        </article>
                        <article className="students-stat">
                            <span className="students-stat__icon students-stat__icon--purple"><FeatherIcon icon="activity" size="20" /></span>
                            <div><strong>{notesCount}</strong><span>Notes saisies</span></div>
                        </article>
                    </section>
                )}

                {this.state.loading && (
                    <div className="students-feedback">
                        <FeatherIcon className="user-search-spin" icon="loader" />
                    </div>
                )}

                {!this.state.loading && this.state.loadError && (
                    <div className="students-feedback students-feedback--error">
                        <FeatherIcon icon="alert-circle" size="30" />
                        <h2>Impossible de charger les évaluations</h2>
                        <p>Vérifiez votre connexion puis réessayez.</p>
                        <button type="button" className="btn btn-primary btn-sm" onClick={this.loadData}>
                            <FeatherIcon icon="refresh-cw" size="15" /> Réessayer
                        </button>
                    </div>
                )}

                {!this.state.loading && !this.state.loadError && sectionGroups.length === 0 && (
                    <div className="students-feedback">
                        <span className="students-feedback__icon"><FeatherIcon icon="clipboard" size="32" /></span>
                        <h2>Aucune évaluation à afficher</h2>
                        <p>Les évaluations apparaîtront ici dès que des séances seront associées aux classes.</p>
                    </div>
                )}

                {!this.state.loading && !this.state.loadError && sectionGroups.length > 0 && (
                    <section className="students-sections">
                        <div className="students-sections__heading">
                            <div>
                                <span>Organisation</span>
                                <h2>Évaluations par section</h2>
                            </div>
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.toggleAllSections(sectionIds)}>
                                <FeatherIcon icon={this.state.displayArray.length === sectionIds.length ? "chevrons-up" : "chevrons-down"} size="16" />
                                {this.state.displayArray.length === sectionIds.length ? "Tout replier" : "Tout déplier"}
                            </button>
                        </div>

                        {sectionGroups.map(({ section, classes }) => {
                            const isOpen = this.state.displayArray.includes(section.id);
                            const totalEvaluations = classes.reduce((sum, item) => sum + item.evaluations.length, 0);
                            return (
                                <article className={`student-section ${isOpen ? "is-open" : ""}`} key={section.id}>
                                    <button type="button" className="student-section__toggle" onClick={() => this.toggleSection(section.id)} aria-expanded={isOpen}>
                                        <span className="student-section__badge">{section.short_entitled_section || "Section"}</span>
                                        <span className="student-section__name">
                                            <strong>{section.entitled_section}</strong>
                                            <small>{classes.length} {classes.length > 1 ? "classes" : "classe"} · {totalEvaluations} {totalEvaluations > 1 ? "évaluations" : "évaluation"}</small>
                                        </span>
                                        <span className="student-section__chevron"><FeatherIcon icon="chevron-down" size="20" /></span>
                                    </button>
                                    {isOpen && (
                                        <div className="student-section__content">
                                            {classes.map((classGroup) => this.renderClass(classGroup, section))}
                                        </div>
                                    )}
                                </article>
                            );
                        })}
                    </section>
                )}

                <EvaluationForm
                    isModal={this.state.isModal}
                    formData={this.state.formData}
                    sectionclasse={this.state.sectionclasse}
                    showModal={this.showModal}
                />

                <NoteForm
                    show={this.state.isNoteModal}
                    evaluationId={this.state.evaluationSelected}
                    close={this.showNoteModal}
                    refresh={this.loadData}
                />
            </main>
        );
    }
}

export default Evaluation;